import React from 'react';
import { useAuth } from '@/contexts/AuthContext';
import FarmerHome from './home/FarmerHome';
import ManufacturerHome from './home/ManufacturerHome';
import DistributorHome from './home/DistributorHome';
import ShopkeeperHome from './home/ShopkeeperHome';
import OfftakerHome from './home/OfftakerHome';
import { Loader2 } from 'lucide-react';

export default function DashboardPage() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <Loader2 className="w-8 h-8 animate-spin text-farm-primary" />
      </div>
    );
  }

  // Route to correct dashboard based on user type
  switch (user?.user_type) {
    case 'manufacturer':
      return <ManufacturerHome />;
    case 'distributor':
      return <DistributorHome />;
    case 'shopkeeper':
      return <ShopkeeperHome />;
    case 'offtaker':
      return <OfftakerHome />;
    case 'farmer':
    default:
      return <FarmerHome />;
  }
}
